import * as React from 'react';
import { Config } from '../helpers';
import { readChartRows, columnsOf, formatCell } from './chartRows';
import { useChartBridge } from './ChartBridgeContext';

// Visible Table view for the chart's Chart/Table toggle. Prefers the current
// filtered selection (published by ResultsBridge) so the table matches the
// chart (B1); falls back to the full injected export when no selection is
// available (e.g. Typesense / cold cache). Columns are the union of populated
// fields, matching MarkdownTableRenderer.
export default function DataTable({ collectionName, fieldLabels = {} }) {
  const { rows: selectionRows } = useChartBridge();
  // null = no selection published (Typesense / before first search) -> fall back
  // to the full export. An empty ARRAY is a real empty selection and must render
  // the no-data message, not the whole dataset.
  const rows = selectionRows ?? readChartRows(collectionName);

  if (!rows || rows.length === 0) {
    return <p className='h--smaller mb-4 text-center'>{Config.I18n.Table.NoData}</p>;
  }

  const headers = columnsOf(rows);

  return (
    <div className='nv-chart__table'>
      <table className='nv-chart__table-inner'>
        <thead>
          <tr>{headers.map(h => <th key={h} title={h}>{headerLabel(h, fieldLabels)}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {headers.map(h => <td key={h}>{formatCell(row[h])}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// A configured chart label wins; otherwise prettify the raw field name
// (snake_case -> Title Case), e.g. "month_year" -> "Month Year".
function headerLabel(field, fieldLabels) {
  if (fieldLabels[field]) return fieldLabels[field];
  return field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
